import Modal from "components/Modal/Modal";
import { getNativeToken } from "config/tokens";
import { useChainId } from "lib/chains";
import { importImage } from "lib/legacy";
import { useState } from "react";
import { MdArrowBack, MdArrowLeft, MdChevronLeft, MdClose } from "react-icons/md";

const ZapModal = ({ visible, setIsVisible }) => {
  const [nativeValue, setNativeValue] = useState(0);
  const [mmyValue, setMMYvalue] = useState(0);
  const [step, setStep] = useState(0);
  const { chainId } = useChainId();
  const nativeImage = importImage(`ic_${getNativeToken(chainId)?.symbol?.toLowerCase()}_24.svg`);
  const mmyImage = importImage(`ic_mmy_24.svg`);
  return (
    <Modal
      isVisible={visible}
      className="zap-in-modal"
      setIsVisible={() => setIsVisible(false)}
      label={`Zap into MMY LP`}
    >
      <div className="zap-in-container">
        <div className="zap-header">
          <div className="back-container">
            <div className="Modal-close-button">
              <MdArrowBack fontSize={24} className="Modal-close-icon" />
            </div>
          </div>
          <div className="title-container">Zap into MMY LP</div>
          <div className="Modal-close-button" onClick={() => setIsVisible(false)}>
            <MdClose fontSize={24} className="Modal-close-icon" />
          </div>
        </div>
        <div className="zap-content-container">
          <div className="step-container">
            <div className="track-line">
              <div className="track-active"></div>
              <div className="dot-container">
                <div className="track-dot">
                  <div className="dot dot-active"></div>
                </div>
                <div className="track-dot">
                  <div className="dot"></div>
                </div>
                <div className="track-dot">
                  <div className="dot"></div>
                </div>
              </div>
              <div className="dot-container track-text-container">
                <div className="track-dot">
                  <div className="track-text">Amount</div>
                </div>
                <div className="track-dot">
                  <div className="track-text">Duration</div>
                </div>
                <div className="track-dot">
                  <div className="track-text">Confirm</div>
                </div>
              </div>
            </div>
          </div>
          <div className="Exchange-swap-section">
            <div className="Exchange-swap-section-top">
              <div className="muted">
                {/* <span>Price</span> */}
              </div>
              <div
                className="muted align-right clickable"
              >
                <span>
                  Balance:{" "}
                </span>
              </div>
            </div>
            <div className="Exchange-swap-section-bottom">
              <div className="Exchange-swap-input-container">
                <input
                  type="number"
                  min="0"
                  placeholder="0.0"
                  className="Exchange-swap-input"
                  value={nativeValue}
                  onChange={setNativeValue}
                />
              </div>
              <div className="token-info-container">
                <img alt="" src={nativeImage} />
                <div className="PositionEditor-token-symbol">{getNativeToken(chainId)?.symbol}</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </Modal>
  )
}
export default ZapModal;
